import { SwPush } from '@angular/service-worker';
import { Injectable } from '@angular/core';
import { ResourcesService } from './resources.service';
import { AppInjector } from '../injector/injector.module';
import { environment } from "../../environment/environment";
import { NavigatorService } from './navigator.service';

@Injectable()
export class NativeNotificationsService
{

    public OnNotificationClicked: any;

    //Pass all notification clicks to it's respective handler
    constructor(private swPush: SwPush, private resources: ResourcesService)
    {
        if (!this.IsSupported()) return;
        this.swPush.notificationClicks.subscribe(event => this.OnNotificationClicked(event.notification.data, event.action, this.NavigateCallback));
    }

    //Since this can run when application is closed, support both navigating using router, and just setting the location
    public NavigateCallback(sURL: string)
    {

        //Any kind of navigation is causing errors, so just disable it for now
        return;

        if (!this.IsSupported()) return;
        try
        {
            var navigator = AppInjector.get(NavigatorService);
            navigator.Navigate([sURL]);
        }
        catch
        {
            location.replace(sURL);
        }
    }

    //Request permission to display notifications
    public RequestNotificationPermission()
    {
        if (!this.IsSupported()) return;
        if (Notification.permission != 'granted') Notification.requestPermission();
    }

    //Shows a desktop notification
    public ShowNotification(options: any)
    {
        try {
            if (!this.IsSupported()) return;
        } catch (e) {
            return;
        }  
        if (navigator.serviceWorker == undefined) return;
        navigator.serviceWorker.getRegistration().then(registration =>
        {
            try
            {
                registration.showNotification(this.resources.RC('AppTitles.Messages'), options as any);
            }
            catch
            {}
        });

    }

    //Check support. on iPhone for instance there is no support
    private IsSupported(): boolean
    {
            return (('Notification' in window) && (environment.production));
    }
}

